<template>
    <div>
        <v-row justify="center">
            <v-dialog
                v-model="dialog"
                persistent
                max-width="330px">
                <v-card>
                    <v-card-title>
                        <div class="mt-2">
                            <img :src="getIconStatus()" />
                        </div>
                        <span
                            class="text-header">
                            {{ head }}
                        </span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row v-html="msg">
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            plain
                            @click="submitBtn()">
                                {{ this.$vuetify.lang.t('$vuetify.checkInOnsite.close') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import IconWarning from '@/assets/icon/icon-warning.png'
import IconError from '@/assets/icon/icon-error.png'
export default {
    props: {
        head: {
            type: String,
            default: 'Some thing wrong'
        },
        msg: {
            type: String,
            default: ''
        },
        isWarning: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            dialog: false,
            message: this.msg
        }
    },

    methods: {
        getIconStatus () {
            if (this.isWarning) {
                return IconWarning
            } else {
                return IconError
            }
        },

        submitBtn () {
            this.$emit('ok-submit')
            this.dialog = false
        }
    }
}
</script>

<style lang="scss" scoped>
img {
    width: 24px;
    height: 24px;
}
.text-header {
    font-size: 18px;
}
</style>
